import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const offer = {
  emoji: '🏆',
  title: 'CALCIO GIOVANILE PRONTO™',
  description: '5 Volumi + 5 Bonus',
  originalPrice: '€67',
  price: '19',
  currency: '€',
  ctaText: '🚀 VOGLIO CALCIO GIOVANILE PRONTO ORA',
  ctaHref: 'https://calcio-giovanile-pronto.impultienda.ar/checkout',
  savings: 'RISPARMI €48'
};
const includes = ['5 Volumi Completi', '5 Bonus Strategici', '250 Allenamenti', '300 Esercizi', 'Accesso a Vita', 'Download Immediato'];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-white py-16 sm:py-24 px-4" data-id="element-127">
      <div className="max-w-xl mx-auto" data-id="element-128">
        <div className="text-center mb-10" data-id="element-129">
          <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-130">
            Tutto incluso,{' '}
            <span className="text-[#16A34A]" data-id="element-131">un solo prezzo.</span>
          </h2>
          <p className="text-[#5A5A66] text-sm sm:text-base font-bold" data-id="element-132">
            Pacchetto completo. Niente upsell. Niente sorprese.
          </p>
        </div>

        <div className="relative bg-white border-2 border-[#16A34A] rounded-3xl pt-10 px-6 sm:px-10 pb-8 sm:pb-10 shadow-xl mb-6 text-center" data-id="element-133">
          {/* Centered top ribbon */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#16A34A] text-white text-[10px] sm:text-xs font-black px-5 py-2 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap" data-id="element-134">
            🏆 PACCHETTO COMPLETO
          </div>

          {/* Title */}
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-135">
            <span className="text-2xl sm:text-3xl" data-id="element-136">{offer.emoji}</span>
            <span className="text-[#0A0A0A] font-black text-lg sm:text-2xl tracking-tight" data-id="element-137">
              {offer.title}
            </span>
          </div>
          <p className="text-[#5A5A66] text-sm sm:text-base font-semibold mb-7" data-id="element-138">
            {offer.description}
          </p>

          {/* Price block — centered */}
          <div className="mb-7 pb-7 border-b border-[#E5E5EA]" data-id="element-139">
            <div className="text-[#5A5A66] line-through text-base font-bold mb-2" data-id="element-140">
              Prezzo originale: {offer.originalPrice}
            </div>
            <div className="flex items-start justify-center gap-1 mb-3" data-id="element-141">
              <span className="font-black text-3xl sm:text-4xl text-[#0A0A0A] mt-2 sm:mt-3" data-id="element-142">
                {offer.currency}
              </span>
              <span className="font-black text-7xl sm:text-8xl text-[#0A0A0A] tracking-tighter leading-none" data-id="element-143">
                {offer.price}
              </span>
            </div>
            <span className="inline-block bg-[#00C853] text-white text-xs font-black px-4 py-2 rounded-full uppercase tracking-widest shadow-md" data-id="element-144">
              {offer.savings}
            </span>
          </div>

          {/* Includes label */}
          <p className="text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-5" data-id="element-145">
            Cosa è incluso
          </p>

          {/* Includes grid — centered */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 max-w-md mx-auto text-left" data-id="element-146">
            {includes.map(item => <div key={item} className="flex items-center gap-2.5" data-id="element-147">
                <span className="text-[#00C853] text-base flex-shrink-0" data-id="element-148">
                  ✅
                </span>
                <span className="text-[#0A0A0A] text-sm font-semibold" data-id="element-149">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mb-6 bg-[#FAFAFA] py-3 rounded-xl border border-[#E5E5EA]" data-id="element-150">
          <span className="text-[#0A0A0A] text-xs sm:text-sm font-black uppercase tracking-wider" data-id="element-151">
            ⏰ Termina tra
          </span>
          <CountdownTimer size="sm" blinking={false} data-id="element-152" />
        </div>

        <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-xl py-5 rounded-2xl transition-colors shadow-lg mb-4" data-id="element-153">
          {offer.ctaText}
        </a>

        <p className="text-[#5A5A66] text-xs text-center mb-6 font-semibold" data-id="element-154">
          💱 Pagherai nella tua valuta locale
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#5A5A66] font-bold" data-id="element-155">
          <span className="flex items-center gap-1.5" data-id="element-156">🔒 Pagamento Sicuro</span>
          <span className="flex items-center gap-1.5" data-id="element-157">⚡ Accesso in 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-158">
            🛡️ Garanzia 7 Giorni
          </span>
          <span className="flex items-center gap-1.5" data-id="element-159">
            💳 Carta · ApplePay · GooglePay
          </span>
        </div>
      </div>
    </section>;
}